// "Try with another model" on a finished build (DES1-specs; ARCH C20). UI1 places it in the
// reveal's next-step row, after the primary step; it is the one control, never a second one.
// One click, no dialog: a new version from the same request; this one stays as it is.
import { formatCopy, useNamespaceCopy } from '@/i18n/ns';
import { buildExperienceCopy } from '@/i18n/ns/build-experience';
import type { BuildAlternative, DisplayAction } from './vm';

/** Shown only when admission offers it; on a finished build a refusal shows nothing at all. */
export function TryWithModel({
  alternative,
  onAction,
}: {
  alternative: BuildAlternative | null;
  onAction: (action: DisplayAction) => void;
}) {
  const copy = useNamespaceCopy(buildExperienceCopy);
  if (alternative?.status !== 'offered') return null;
  const { action } = alternative;
  return (
    <button
      type="button"
      className="pc-btn"
      data-variant="quiet"
      data-action="try-with"
      disabled={action.status !== 'available'}
      aria-busy={action.status === 'pending' || undefined}
      onClick={() => action.status === 'available' && onAction(action)}
    >
      {formatCopy(copy.tryWith, { model: alternative.model.shortName })}
    </button>
  );
}

/** The quiet "Compare with v<n>" on the new version's reveal, opening the existing compare. */
export function CompareWithVersion({ n, onCompare }: { n: number; onCompare: () => void }) {
  const copy = useNamespaceCopy(buildExperienceCopy);
  return (
    <button
      type="button"
      className="pc-btn"
      data-variant="quiet"
      data-action="compare"
      onClick={onCompare}
    >
      {formatCopy(copy.compareWith, { n: String(n) })}
    </button>
  );
}
